module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/coupons/discount-type/create-discount-type/create-discount-type.component.scss
// module id = ./src/app/coupons/discount-type/create-discount-type/create-discount-type.component.scss
// module chunks = main